import { render, staticRenderFns } from "./logisticsInfo.vue?vue&type=template&id=0e47a304&scoped=true&"
import script from "./logisticsInfo.vue?vue&type=script&lang=js&"
export * from "./logisticsInfo.vue?vue&type=script&lang=js&"
import style0 from "./logisticsInfo.vue?vue&type=style&index=0&id=0e47a304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e47a304",
  null
  
)

export default component.exports